import clsx from 'clsx';
import { useEffect, useState } from 'react';

interface MapDotProps {
  className?: string;
}

const MapDot = ({ className }: MapDotProps) => {
  const [randomDelay, setRandomDelay] = useState(0);
  const [hasDelayPassed, setHasDelayPassed] = useState(false);

  useEffect(() => {
    setRandomDelay(Math.floor(Math.random() * 5000));
  }, []);

  useEffect(() => {
    if (randomDelay !== 0) {
      const timeout = setTimeout(() => {
        setHasDelayPassed(true);
      }, randomDelay);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [randomDelay]);

  return (
    <div className={clsx(`absolute`, className)}>
      <span className="relative flex justify-center items-center">
        <span
          className={`absolute inline-flex h-[100px] w-[100px] animate-ping rounded-full ${hasDelayPassed ? 'bg-[#D3EDFE]' : ''} opacity-75`}
          style={{
            animationDelay: `${randomDelay}ms`,
            animationDuration: '5s',
          }}
        />
        <span className="relative inline-flex h-[52px] w-[52px] rounded-full bg-[#E9E8AB]" />
      </span>
    </div>
  );
};

export default MapDot;
